import apiService from './apiService';
import {
    ApiViewEntityResponse, ApplicationModel, UserPasswordModel, CurrentUserModel
} from '../interfaces';
import { HTTP_METHOD, REACT_APP_IDENTITY_API_BASE_URL } from "../constants";
import { CountryModel, UserAddressModel, UserContactDataModel, UserModel, UserPersonalDetailsModel } from '../interfaces';

export default {
    async getApplications(): Promise<ApiViewEntityResponse<ApplicationModel[]>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/applications`, {
            method: HTTP_METHOD.GET
        });
        const result: ApiViewEntityResponse<ApplicationModel[]> = await response.json()
        return result;
    },

    async getCountries(): Promise<ApiViewEntityResponse<CountryModel[]>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/countries`, {
            method: HTTP_METHOD.GET
        });
        const result: ApiViewEntityResponse<CountryModel[]> = await response.json()
        return result;
    },

    async getCurrentUser(): Promise<ApiViewEntityResponse<CurrentUserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me`, {
            method: HTTP_METHOD.GET
        });
        const result: ApiViewEntityResponse<CurrentUserModel> = await response.json()
        return result;
    },

    async getCurrentUserApplications(): Promise<ApiViewEntityResponse<ApplicationModel[]>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/applications`, {
            method: HTTP_METHOD.GET
        });
        const result: ApiViewEntityResponse<ApplicationModel[]> = await response.json()
        return result;
    },

    async updateUserPersonalDetails(personalDetails: UserPersonalDetailsModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/personal-details`, {
            method: HTTP_METHOD.PUT,
            body: JSON.stringify(personalDetails)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async updateUserName(userName: string): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/userName`, {
            method: HTTP_METHOD.PUT,
            body: JSON.stringify({ userName: userName })
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async createUserAddress(userAddress: UserAddressModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/addresses`, {
            method: HTTP_METHOD.POST,
            body: JSON.stringify(userAddress)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async updateUserAddress(userAddressId: number, userAddress: UserAddressModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/addresses/${userAddressId}`, {
            method: HTTP_METHOD.PUT,
            body: JSON.stringify(userAddress)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async createUserContact(contact: UserContactDataModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/contacts`, {
            method: HTTP_METHOD.POST,
            body: JSON.stringify(contact)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async updateUserContact(contactId: number, contact: UserContactDataModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/contacts/${contactId}`, {
            method: HTTP_METHOD.PUT,
            body: JSON.stringify(contact)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async deleteUserContact(contactId: number): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/contacts/${contactId}`, {
            method: HTTP_METHOD.DELETE,
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    },

    async changeUserPassword(request: UserPasswordModel): Promise<ApiViewEntityResponse<UserModel>> {
        let response = await apiService.fetch(`${REACT_APP_IDENTITY_API_BASE_URL}/v1/users/me/password`, {
            method: HTTP_METHOD.PUT,
            body: JSON.stringify(request)
        });
        const result: ApiViewEntityResponse<UserModel> = await response.json()
        return result;
    }
}
